import React, { useEffect, useState } from 'react';
import { Empty } from 'antd';
import styled from 'styled-components';
import { PortalIcon } from 'utils/baochauTheme';
const LabelCheckbox = styled.label``;
const ContentRender = styled.span`
  margin-left: ${(props) => props.levelRecursive};
  opacity: ${(props) => (props.disable ? '0.2' : '1')};
  cursor: ${(props) => (props.disable ? 'default' : 'pointer')};
`;

const TrTable = ({
  colSpan,
  keyRender,
  flag,
  noSelect,
  hiddenRowSelect,
  indexValue,
  _dataSelect,
  setDataSelect,
  leadingColumns,
  columns,
  valueRender,
  findIndex,
  rowAction,
  renderRowAction,
  getChildren,
  levelRecursive,
  parentField,
  onChangeSelect,
  uniqueSelect,
  detailTr,
  onRowClick,
}) => {
  const [openExpaned, setOpenExpaned] = useState(false);
  const [dataExpaned, setDataExpaned] = useState(undefined);
  // const marginRecursive = levelRecursive ? `${levelRecursive * 5 + 10}px` : '10px';
  const [init, setInit] = useState(true);
  const marginRecursive = levelRecursive ? `${levelRecursive * 9 + 10}px` : '10px';
  const MIN_LENGTH_ACTION = 35;
  const hasChildren = Number(valueRender?.child_count) !== 0;

  const handleToggleChildren = () => {
    if (!hasChildren) {
      return;
    }

    setOpenExpaned(!openExpaned);
    setInit(false);
    if (!dataExpaned) {
      getChildren({
        parent_id: valueRender[`${parentField}`],
      }).then((data) => setDataExpaned(data?.items));
    }
  };

  const renderExpandToggle = () => (
    <ContentRender
      levelRecursive={marginRecursive}
      disable={!hasChildren}
      onClick={handleToggleChildren}
      className={`bw_show_child${hasChildren ? '' : ' bw_show_child_leaf'}`}>
      {hasChildren ? <PortalIcon icon={`fi fi-rr-${openExpaned ? 'minus' : 'plus'}-small`} /> : null}
    </ContentRender>
  );

  const jsx_render = () => {
    if (openExpaned) {
      if (Array.isArray(dataExpaned) && dataExpaned.length > 0) {
        return dataExpaned.map((valueR, childIndex) => {
          return (
            <TrTable
              key={`${valueR?.[parentField] ?? valueR?.id ?? keyRender}-${childIndex}`}
              colSpan={colSpan}
              keyRender={keyRender}
              flag={flag}
              noSelect={noSelect}
              hiddenRowSelect={hiddenRowSelect}
              indexValue={indexValue}
              _dataSelect={_dataSelect}
              setDataSelect={setDataSelect}
              leadingColumns={leadingColumns}
              columns={columns}
              valueRender={valueR}
              findIndex={findIndex}
              rowAction={rowAction}
              renderRowAction={renderRowAction}
              getChildren={getChildren}
              levelRecursive={(levelRecursive ? levelRecursive : 0) + 1}
              parentField={parentField}
              onChangeSelect={onChangeSelect}
              uniqueSelect={uniqueSelect}
              detailTr={detailTr}
              onRowClick={onRowClick}
            />
          );
        });
      } else {
        return (
          <tr>
            <td colSpan={colSpan}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='Không có dữ liệu' />
            </td>
          </tr>
        );
      }
    }
  };

  useEffect(() => {
    const expandColumn = columns.find((column) => column.expanded);
    if (expandColumn) {
      if (valueRender.child_count !== 0 && !openExpaned && init) {
        setOpenExpaned(true);
        if (!dataExpaned) {
          getChildren({
            parent_id: valueRender[`${parentField}`],
          }).then((data) => setDataExpaned(data?.items));
        }
      }
    }
  }, [columns, dataExpaned, getChildren, openExpaned, parentField, valueRender, init]);

  const renderColumns = (columnList = [], keyPrefix = 'column') =>
    columnList
      .filter((column) => !column.hidden)
      .map((column, key) => {
        const className = [
          column?.classNameBody || '',
          column?.isResized ? 'bw_resized_cell' : '',
        ]
          .filter(Boolean)
          .join(' ');
        const cellKey = `${keyRender}-${keyPrefix}-${column?.key || column?.accessor || key}`;
        const cellStyle = typeof column?.style === 'function' ? column.style(valueRender) : column?.style;
        const handleDetailClick = () =>
          detailTr && column?.accessor !== 'full_name' ? window._$g.rdr(`/orders/detail/${valueRender?.order_id}`) : '';

        if (column.formatter) {
          return (
            <td onClick={handleDetailClick} style={cellStyle} className={className} key={cellKey}>
              {column.expanded && renderExpandToggle()}
              <span className='bw_table_cell_content'>{column.formatter(valueRender, keyRender)}</span>
            </td>
          );
        }

        if (column.accessor) {
          const cellValue = valueRender[column.accessor];
          return (
            <td
              onClick={handleDetailClick}
              style={cellStyle}
              className={className}
              title={
                cellValue === null || cellValue === undefined || typeof cellValue === 'object'
                  ? undefined
                  : String(cellValue)
              }
              key={cellKey}>
              {column.expanded && renderExpandToggle()}
              <span className='bw_table_cell_content'>{cellValue}</span>
            </td>
          );
        }

        return (
          <td onClick={handleDetailClick} style={cellStyle} className={className} key={cellKey}>
            {column.expanded && renderExpandToggle()}
          </td>
        );
      });

  return (
    <>
      <tr
        key={keyRender}
        className={flag ? 'bw_checked' : ''}
        style={{ cursor: detailTr || onRowClick ? 'pointer' : '' }}
        onClick={(event) => {
          if (!onRowClick || event.target.closest('button, a, input, label, select, textarea, [role="button"]')) {
            return;
          }
          onRowClick(valueRender);
        }}>
        {!noSelect && (
          <td className='bw_sticky bw_check_sticky'>
            <LabelCheckbox
              style={{
                marginRight: '2px',
                display: `${typeof hiddenRowSelect === 'function' && hiddenRowSelect(valueRender) ? 'none' : ''}`,
              }}
              className='bw_checkbox'>
              <input
                type='checkbox'
                checked={flag}
                key={keyRender}
                onChange={(e) => {
                  let dataCurrent;
                  if (flag) {
                    _dataSelect.splice(findIndex, 1);
                    setDataSelect(_dataSelect);
                    dataCurrent = _dataSelect;
                  } else {
                    if (uniqueSelect) {
                      setDataSelect([valueRender]);
                      dataCurrent = [valueRender];
                    } else {
                      setDataSelect([..._dataSelect, valueRender]);
                      dataCurrent = [..._dataSelect, valueRender];
                    }

                  }
                  onChangeSelect(dataCurrent, { ...valueRender, isChecked: e.target.checked ? 1 : 0 });
                }}
              />
              <span></span>
            </LabelCheckbox>
          </td>
        )}
        {renderColumns(leadingColumns, 'leading')}
        <td className='bw_sticky bw_no_sticky bw_text_center'>{indexValue}</td>
        {renderColumns(columns, 'data')}
        {Boolean(rowAction?.length) && (
          <td
            style={{ minWidth: `${rowAction.length * MIN_LENGTH_ACTION}px`, zIndex: 2 }}
            className='bw_sticky bw_action_table bw_text_center'>
            {renderRowAction(valueRender, keyRender)}
          </td>
        )}
      </tr>
      {jsx_render()}
    </>
  );
};

export default TrTable;
